import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import languageSlice from './LanguageProvider';
import loginUserInfoSlice from './LoginUserInfoProvider';
import snackBarSlice from './SnackBarProvider';

const rootReducers = combineReducers({
  language: languageSlice.reducer,
  snackBar: snackBarSlice.reducer,
  loginUserInfo: loginUserInfoSlice.reducer,
});

/*
  [Stones] 새로 고침 시 Redux에서 관리하는 데이터의 초기화를 방지해주는 라이브러리.
*/
const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
